import {
  IArticleVideoMixed,
  IPlaylist,
  IVideo,
  IVideoArticleList,
} from './types';

export const DESKTOP_WIDTH = 768;
export const MOBILE_WIDTH = DESKTOP_WIDTH + 1;
export const PDF_FORMAT = 'PDF';
export const OPEN_PDF_FORMAT = 'Open PDF';
export const PDF_DATA =
  '{"id":"1_yodc1x6s","name":"Uncover market trends with What\'s Market","description":"Practical Law- What\'s Market","partnerId":2563011,"userId":"mark.s.foster@thomsonreuters.com","creatorId":"mark.s.foster@thomsonreuters.com","tags":"drafting_documents, practical law","adminTags":"__pdfentry,__sub_draft_entry_type","categories":"","categoriesIds":"","status":7,"moderationStatus":6,"moderationCount":0,"type":1,"createdAt":1671221078,"updatedAt":1706121444,"rank":0,"totalRank":0,"votes":0,"downloadUrl":"https://cdnapisec.kaltura.com/p/2563011/sp/256301100/playManifest/entryId/1_yodc1x6s/format/download/protocol/https/flavorParamIds/0","searchText":"_PAR_ONLY_ _2563011_ _MEDIA_TYPE_1|  Uncover market trends with Whats Market drafting_documents, practical law Practical Law- Whats Market __pdfentry,__sub_draft_entry_type","licenseType":-1,"version":0,"thumbnailUrl":"https://cfvod.kaltura.com/p/2563011/sp/256301100/thumbnail/entry_id/1_yodc1x6s/version/100031","accessControlId":2729781,"replacementStatus":0,"partnerSortValue":0,"rootEntryId":"1_yodc1x6s","operationAttributes":[],"entitledUsersEdit":"adminuser,0096227","entitledUsersPublish":"","entitledUsersView":"","capabilities":"","displayInSearch":1,"application":"1","blockAutoTranscript":false,"plays":67,"views":104,"lastPlayedAt":1738634400,"duration":0,"msDuration":0,"mediaType":1,"sourceType":"6","dataUrl":"https://cdnapisec.kaltura.com/p/2563011/sp/256301100/playManifest/entryId/1_yodc1x6s/format/url/protocol/https","objectType":"KalturaMediaEntry"}';
export const VIDEO_DATA =
  '{"id":"1_yodc1x6s","name":"Uncover market trends with What\'s Market","description":"Practical Law- What\'s Market","partnerId":2563011,"userId":"mark.s.foster@thomsonreuters.com","creatorId":"mark.s.foster@thomsonreuters.com","tags":"drafting_documents, practical law","adminTags":"__pdfentry,__sub_draft_entry_type","categories":"","categoriesIds":"","status":7,"moderationStatus":6,"moderationCount":0,"type":1,"createdAt":1671221078,"updatedAt":1706121444,"rank":0,"totalRank":0,"votes":0,"downloadUrl":"https://cdnapisec.kaltura.com/p/2563011/sp/256301100/playManifest/entryId/1_yodc1x6s/format/download/protocol/https/flavorParamIds/0","searchText":"_PAR_ONLY_ _2563011_ _MEDIA_TYPE_1|  Uncover market trends with Whats Market drafting_documents, practical law Practical Law- Whats Market __sub_draft_entry_type","licenseType":-1,"version":0,"thumbnailUrl":"https://cfvod.kaltura.com/p/2563011/sp/256301100/thumbnail/entry_id/1_yodc1x6s/version/100031","accessControlId":2729781,"replacementStatus":0,"partnerSortValue":0,"rootEntryId":"1_yodc1x6s","operationAttributes":[],"entitledUsersEdit":"adminuser,0096227","entitledUsersPublish":"","entitledUsersView":"","capabilities":"","displayInSearch":1,"application":"1","blockAutoTranscript":false,"plays":67,"views":104,"lastPlayedAt":1738634400,"duration":0,"msDuration":0,"mediaType":1,"sourceType":"6","dataUrl":"https://cdnapisec.kaltura.com/p/2563011/sp/256301100/playManifest/entryId/1_yodc1x6s/format/url/protocol/https","objectType":"KalturaMediaEntry"}';

export const article_images = [
  '/content/dam/helpandsupp/en-us/resources/images/article_vector_1.jpg',
  '/content/dam/helpandsupp/en-us/resources/images/article_vector_2.jpg',
  '/content/dam/helpandsupp/en-us/resources/images/article_vector_3.jpg',
  '/content/dam/helpandsupp/en-us/resources/images/article_vector_4.jpg',
  '/content/dam/helpandsupp/en-us/resources/images/article_vector_5.jpg',
  '/content/dam/helpandsupp/en-us/resources/images/article_vector_6.jpg',
  '/content/dam/helpandsupp/en-us/resources/images/article_vector_7.jpg',
  '/content/dam/helpandsupp/en-us/resources/images/article_vector_8.jpg',
];

export const articleTile = [
  {
    heading: 'Outline Builder',
    segmentationTitle: 'Feature',
    segmentationText: 'Bussiness Law center',
    articleFormat: 'Article',
    articleReadTime: '1 min read',
    articleDescription:
      'Identify the specific point of law in a case that has been invalidated so that other valid points of law aren’t missed',
    articleLinkHref: 'https://www.google.com',
    articleLinkText: 'Google',
    isNewTab: true,
    badge: 'New',
  },
  {
    heading: 'Outline Builder 2',
    segmentationTitle: 'Feature',
    segmentationText: 'Bussiness Law center',
    articleFormat: 'PDF',
    articleSize: '4MB',
    articleReadTime: '1 min read',
    articleDescription:
      'Identify the specific point of law in a case that has been invalidated so that other valid points of law aren’t missed',
    articleLinkHref: 'https://www.google.com',
    articleLinkText: 'Google',
    isNewTab: false,
    badge: 'Updated',
  },
  {
    heading: 'Outline Builder 3',
    segmentationTitle: 'Feature',
    segmentationText: 'Bussiness Law center',
    articleFormat: 'File',
    articleSize: '4MB',
    articleReadTime: '1 min read',
    articleDescription:
      'Identify the specific point of law in a case that has been invalidated so that other valid points of law aren’t missed',
    articleLinkHref: 'https://www.google.com',
    articleLinkText: 'Google',
    isNewTab: true,
    badge: '',
  },
  {
    heading:
      'Identify the specific point of law in a case that has been invalidated so that other valid points of law aren’t missed',
    segmentationTitle: 'Feature',
    segmentationText: 'Bussiness Law center',
    articleFormat: 'PDF',
    articleSize: '4MB',
    articleReadTime: '1 min read',
    articleDescription:
      'Identify the specific point of law in a case that has been invalidated so that other valid points of law aren’t missed',
    articleLinkHref: 'https://www.google.com',
    articleLinkText: 'Google',
    isNewTab: false,
    badge: '',
  },
  {
    heading: 'Outline Builder 3',
    segmentationTitle: 'Feature',
    segmentationText: 'Bussiness Law center',
    articleFormat: 'Video',
    articleSize: '4MB',
    articleReadTime: '1 min read',
    articleDescription:
      'Identify the specific point of law in a case that has been invalidated so that other valid points of law aren’t missed',
    articleLinkHref: 'https://www.google.com',
    articleLinkText: 'Google',
    isNewTab: true,
    badge: 'Updated',
  },
  {
    heading: 'Outline Builder 3',
    segmentationTitle: 'Feature',
    segmentationText: 'Bussiness Law center',
    articleFormat: '',
    articleSize: '4MB',
    articleReadTime: '1 min read',
    articleDescription:
      'Identify the specific point of law in a case that has been invalidated so that other valid points of law aren’t missed',
    articleLinkHref: 'https://www.google.com',
    articleLinkText: 'Google',
    isNewTab: true,
    badge: 'Updated',
  },
];

export const articleTileReversed = [
  {
    heading:
      'Identify the specific point of law in a case that has been invalidated so that other valid points of law aren’t missed',
    segmentationTitle: 'Feature',
    segmentationText: 'Bussiness Law center',
    articleFormat: 'PDF',
    articleSize: '4MB',
    articleReadTime: '1 min read',
    articleDescription:
      'Identify the specific point of law in a case that has been invalidated so that other valid points of law aren’t missed',
    articleLinkHref: 'https://www.google.com',
    articleLinkText: 'Google',
    isNewTab: false,
    badge: '',
  },
  {
    heading: 'Outline Builder 3',
    segmentationTitle: 'Feature',
    segmentationText: 'Bussiness Law center',
    articleFormat: 'Video',
    articleSize: '4MB',
    articleReadTime: '1 min read',
    articleDescription:
      'Identify the specific point of law in a case that has been invalidated so that other valid points of law aren’t missed',
    articleLinkHref: 'https://www.google.com',
    articleLinkText: 'Google',
    isNewTab: true,
    badge: 'Updated',
  },
  {
    heading: 'Outline Builder',
    segmentationTitle: 'Feature',
    segmentationText: 'Bussiness Law center',
    articleFormat: '',
    articleReadTime: '1 min read',
    articleDescription:
      'Identify the specific point of law in a case that has been invalidated so that other valid points of law aren’t missed that has been invalidated so that other valid points',
    articleLinkHref: 'https://www.google.com',
    articleLinkText: 'Google',
    isNewTab: true,
    badge: '',
  },
];

export const articleTile1 = [
  {
    heading: 'Outline Builder',
    segmentationTitle: 'Feature',
    segmentationText: 'Bussiness Law center',
    articleFormat: 'Article',
    articleReadTime: '1 min read',
    articleDescription:
      'Identify the specific point of law in a case that has been invalidated so that other valid points of law aren’t missed',
    articleLinkHref: 'https://www.google.com',
    articleLinkText: 'Google',
    isNewTab: true,
    badge: 'New',
  },
];

export const videoPlaylistDetailsMock: IPlaylist = {
  title: 'video PlayList heading',
  subTitle: 'sub title',
  partnerId: '2563011',
  secretKey: '1ecae30b83a4d215de80f5a53b844d1c',
  privileges: 'disableentitlement',
  playlistEntryId: '1_dq71zh42',
};

export const videoPlaylistDetailsMock1: IPlaylist = {
  title: 'video PlayList heading',
  subTitle: 'sub title 2',
  partnerId: '2563011',
  secretKey: '1ecae30b83a4d215de80f5a53b844d1c',
  privileges: 'disableentitlement',
  playlistEntryId: '1_wg8kqjui',
};

export const mockVideoTile: IVideo = {
  partnerId: '2563011',
  secretKey: '1ecae30b83a4d215de80f5a53b844d1c',
  privileges: 'disableentitlement',
  videoDetails: [
    {
      videoFormat: 'Course',
      videoLinkHref: 'https://www.google.com',
      videoLinkText: 'Open Video',
      isNewTab: true,
      entryId: '1_yodc1x6s',
    },
    {
      videoFormat: 'Video',
      videoLinkHref: 'https://www.google.com',
      videoLinkText: 'Google',
      isNewTab: true,
      entryId: '1_k9k9oqtn',
    },
  ],
};

export const mockVideo1Tile: IVideo = {
  partnerId: '2563011',
  secretKey: '1ecae30b83a4d215de80f5a53b844d1c',
  privileges: 'disableentitlement',
  videoDetails: [
    {
      videoFormat: 'Course',
      videoLinkHref: 'https://www.google.com',
      videoLinkText: 'Google',
      isNewTab: true,
      entryId: '1_4uitn2po',
    },
  ],
};

export const mockVideo0Tile: IVideo = {
  partnerId: '2563011',
  secretKey: '1ecae30b83a4d215de80f5a53b844d1c',
  privileges: 'disableentitlement',
  videoDetails: [],
};

export const mockVideoArticleTemplate: IVideoArticleList = {
  heading: 'mock heading',
  articles: articleTile,
  video: mockVideoTile,
  videoPlaylist: videoPlaylistDetailsMock,
  template: 'ArticleVideoCards',
};

export const mockVideoArticleMixedData: IArticleVideoMixed[] = [
  {
    articleHeading: 'Outline Builder',
    articleSegmentationTitle: 'Feature',
    articleSegmentationText: 'Bussiness Law center',
    articleSize: '4MB',
    articleReadTime: '1 min read',
    articleDescription:
      'Identify the specific point of law in a case that has been invalidated so that other valid points of law aren’t missed',
    linkHref: 'https://www.google.com',
    linkText: 'Google',
    articleBadge: 'New',
    format: 'Article',
    isNewTab: true,
  },
  {
    articleHeading:
      'Identify the specific point of law in a case that has been invalidated so that other valid points of law',
    articleSegmentationTitle: 'Feature',
    articleSegmentationText: 'Bussiness Law center',
    articleSize: '4MB',
    articleReadTime: '1 min read',
    articleDescription:
      'Identify the specific point of law in a case that has been invalidated so that other valid points of law aren’t missed',
    linkHref: 'https://www.google.com',
    linkText: 'Google',
    articleBadge: 'New',
    format: 'Article',
    isNewTab: true,
  },
  {
    entryId: '1_yodc1x6s',
    format: 'Video',
    isNewTab: true,
    linkHref: 'https://www.google.com',
    linkText: 'Google',
  },

  {
    entryId: '1_vdcphntg',
    format: 'Video',
    isNewTab: false,
    linkHref: 'https://www.google.com',
    linkText: 'Google',
  },
  {
    articleHeading: 'Outline Builder',
    articleSegmentationTitle: 'Feature',
    articleSegmentationText: 'Bussiness Law center',
    articleSize: '4MB',
    articleReadTime: '1 min read',
    articleDescription:
      'Identify the specific point of law in a case that has been invalidated so that other valid points of law aren’t missed',
    linkHref: 'https://www.google.com',
    linkText: 'Google',
    articleBadge: 'New',
    format: 'Article',
    isNewTab: true,
  },
  {
    articleHeading:
      'Identify the specific point of law in a case that has been invalidated so that other valid points of law',
    articleSegmentationTitle: 'Feature',
    articleSegmentationText: 'Bussiness Law center',
    articleSize: '4MB',
    articleReadTime: '1 min read',
    articleDescription:
      'Identify the specific point of law in a case that has been invalidated so that other valid points of law aren’t missed',
    linkHref: 'https://www.google.com',
    linkText: 'Google',
    articleBadge: 'New',
    format: 'PDF',
    isNewTab: false,
  },
  {
    articleHeading:
      'Identify the specific point of law in a case that has been invalidated so that other valid points of law',
    articleSegmentationTitle: 'Feature',
    articleSegmentationText: 'Bussiness Law center',
    articleSize: '4MB',
    articleReadTime: '1 min read',
    articleDescription:
      'Identify the specific point of law in a case that has been invalidated so that other valid points of law aren’t missed',
    linkHref: 'https://www.google.com',
    linkText: 'Google',
    articleBadge: 'New',
    format: 'File',
    isNewTab: false,
  },
  {
    articleSize: '4MB',
    linkHref: 'https://www.google.com',
    linkText: 'Google',
    articleBadge: 'New',
    format: 'File',
    isNewTab: false,
  },
  {
    entryId: '1_vdcphntg',
    format: 'Course',
    isNewTab: true,
    linkHref: 'https://www.google.com',
    linkText: 'Google',
  },
  {
    articleHeading: 'Outline Builder',
    articleSegmentationTitle: 'Feature',
    articleSegmentationText: 'Bussiness Law center',
    articleSize: '4MB',
    articleReadTime: '1 min read',
    articleDescription:
      'Identify the specific point of law in a case that has been invalidated so that other valid points of law aren’t missed',
    linkHref: 'https://www.google.com',
    linkText: 'Google',
    articleBadge: 'New',
    format: '',
    isNewTab: true,
  },
];

export const mockVideoArticleMixedTemplate: IVideoArticleList = {
  heading: 'mock heading',
  articles: articleTile,
  video: mockVideoTile,
  videoPlaylist: videoPlaylistDetailsMock,
  template: 'ArticleVideoCards',
  articleVideoMixed: mockVideoArticleMixedData,
  partnerId: '2563011',
  secretKey: '1ecae30b83a4d215de80f5a53b844d1c',
  privileges: 'disableentitlement',
};

export const mockVideoArticleMixedTemplateWithBlankData: IVideoArticleList = {
  heading: 'mock heading',
  articles: articleTile,
  video: mockVideoTile,
  videoPlaylist: videoPlaylistDetailsMock,
  template: 'ArticleVideoCards',
};

export const mock2VideoTile1ArticleTileTemplate: IVideoArticleList = {
  heading: 'mock heading',
  articles: articleTile1,
  video: mockVideoTile,
  videoPlaylist: videoPlaylistDetailsMock,
  template: 'ArticleVideoCards',
};

export const mockVideoArticle1Video3ArticleTemplate: IVideoArticleList = {
  heading: 'mock heading',
  articles: articleTile,
  video: mockVideo1Tile,
  videoPlaylist: videoPlaylistDetailsMock,
  template: 'ArticleVideoCards',
};

export const mockVideoArticle1Video3Article2Template: IVideoArticleList = {
  heading: 'mock heading',
  articles: articleTileReversed,
  video: mockVideo1Tile,
  videoPlaylist: videoPlaylistDetailsMock,
  template: 'ArticleVideoCards',
};

export const mockArticleVideoPlayListTemplate: IVideoArticleList = {
  heading: 'mock heading',
  articles: articleTile,
  video: mockVideoTile,
  videoPlaylist: videoPlaylistDetailsMock,
  template: 'ArticleVideoList',
};

export const mockArticleVideoPlayListTemplateWithoutArticles: IVideoArticleList = {
  heading: 'mock heading',
  videoPlaylist: videoPlaylistDetailsMock1,
  template: 'ArticleVideoList',
};

export const mockArticle1VideoPlayListTemplate: IVideoArticleList = {
  heading: 'mock heading',
  articles: articleTile.slice(0, 1),
  video: mockVideoTile,
  videoPlaylist: videoPlaylistDetailsMock,
  template: 'ArticleVideoList',
};

export const article1Video0Template: IVideoArticleList = {
  heading: 'mock heading',
  articles: articleTileReversed,
  video: mockVideo0Tile,
  videoPlaylist: videoPlaylistDetailsMock,
  template: 'ArticleVideoCards',
};

export const article0Video1Template: IVideoArticleList = {
  heading: 'mock heading',
  video: mockVideoTile,
  videoPlaylist: videoPlaylistDetailsMock,
  template: 'ArticleVideoCards',
};

export const mockArticle0VideoPlayList1Template: IVideoArticleList = {
  heading: 'mock heading',
  video: mockVideoTile,
  videoPlaylist: videoPlaylistDetailsMock,
  template: 'ArticleVideoList',
};

export const articleVideoTemplateType = 'ArticleVideoCards';

export const mockApiResponse =
  '{"playlistContent":"1_aheyrtnv,1_ae2lu5we,1_h608sp4r,1_c7zmgod0","objectType":"KalturaPlaylist"}';
